

export default {
    port: {
        login: {
            title: '登入你的账户',
            username: '请输入用户名',
            password: '请输入密码',
            save: "记住密码",
            login: '登录',
            forget: '忘记密码？',
            password_login: '密码登录',
            vercode_login: '验证码登录',
            login_now: '正在登录中，请稍后...',
            phone_login: '通过手机登录',
            mfa_verf: '通过安全验证',
            mfa_phone_verf: '通过绑定的手机验证',
            phone_risk: '检测到您的账户可能有安全风险，需要验证您的手机号',
            input_textcode: '请输入您收到的短信验证码',
            input_phone: '请输入手机号',
            send_code: '发送验证码',
            input_phone_code: '输入手机验证码',
            change_verf_type: '使用其他方式验证',
            input_six_number: '请输入6位数字验证码',
            reset_password: '重置密码',
            choose_verf_type: '选择验证类型',
            phone_number: '手机号',
            send_text_code: '发送短信验证码',
            verfcode: '验证码',
            short_text: '短信',
            email_click_next: '已发送邮件，请在邮件中点击链接进行后续操作',
            reset_success: '重置成功！即将跳转登录页面',
            mfa_verfer: '通过验证器验证',
            input_mfa_verf_code: '请输入验证器中的验证码',
            input_verf_code: '输入验证码',
            forget: '忘记密码',
            email: '邮箱',
            submit: '提交',
            social_login: '社交账号登录',
            dingtalk: '钉钉',
            wechat: '微信',
            qlinyun: '麒麟云',
            qlinyundev: '麒麟云测试',
            bizark: '四海商舟'
        },
        reset: {
            title: '找回密码',
            email: '电子邮件地址',
            submit: '发送密码重置链接邮件',
            password: '请输入新密码',
            repassword: '请确认密码',
            reset: "重置密码"
        },
        profile: {
            title: '用户资料',
            nick: '用户昵称:',
            email: '登录邮箱:',
            ep: '修改资料',
            submit: '提交修改',
            reset: '重置',
        },
        connections: {
            title: '社交账号绑定',
            loading: '处理中，请稍候...',
            action_connect:'绑定',
            action_disconnect:'解除绑定',
            action_connect_success:'绑定成功',
            action_connect_failed:'绑定失败: ',
            action_disconnect_success:'解除绑定成功',
            action_disconnect_failed:'解除绑定失败',
            source_dingtalk:'钉钉',
            source_wechat:'微信'
        },
        password: {
            title: '用户密码修改',
            nick: '用户昵称:',
            password: '当前密码:',
            new_password: ' 新密码:',
            re_password: '确认密码:',
            submit: '修改密码',
            home: '返回首页',
            required:'密码不能为空',
            same_password:'确认密码一致',
            rule:'必须至少包含1个数字，1个字母,密码长度不能少于六位'
        },
        panel_info:{
            info:'用户信息',
            user:'当前用户',
            ip:'最近登录IP',
            attime:'最近登录时间',
            updated:'最近修改密码时间',
        }
    }
}

